module.exports = __webpack_public_path__ + "static/media/input-icon-person~fHUjPibg.2856a6ed.svg";